import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { RecalculateSummarySalesPageRoutingModule } from './recalculate-summary-sales-routing.module';

import { RecalculateSummarySalesPage } from './recalculate-summary-sales.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    RecalculateSummarySalesPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [RecalculateSummarySalesPage]
})
export class RecalculateSummarySalesPageModule {}
